import { F0Select } from '@factorialco/f0-react'
import { FinanceEnumsQuoteTypeEnum } from 'generated/resources/graphql'

import { useMemo } from 'modules/core/hooks/useMemo'
import i18n from 'modules/core/lib/i18n'

interface QuoteTypeSelectorProps {
  value?: FinanceEnumsQuoteTypeEnum
  onChange: (value: FinanceEnumsQuoteTypeEnum) => void
  label?: string
  error?: string
  disabled?: boolean
  size?: 'sm' | 'md' | 'lg'
}

const translateQuoteType = (quoteType: FinanceEnumsQuoteTypeEnum): string => {
  switch (quoteType) {
    case 'products':
      return i18n.t('finance.quotes.quote_type.product')
    case 'timeandmaterials':
      return i18n.t('finance.quotes.quote_type.time_and_materials')
    default:
      return ''
  }
}

export const QuoteTypeSelector = ({
  value,
  onChange,
  label,
  error,
  disabled,
  size = 'md',
}: QuoteTypeSelectorProps) => {
  const buildOptions = useMemo(() => {
    const quoteTypeOptions: FinanceEnumsQuoteTypeEnum[] = ['products', 'timeandmaterials']

    return quoteTypeOptions.map((quoteType) => ({
      label: translateQuoteType(quoteType),
      value: quoteType,
    }))
  }, [])

  return (
    <F0Select
      size={size}
      label={label}
      options={buildOptions}
      value={value ?? undefined}
      onChange={(newValue: FinanceEnumsQuoteTypeEnum) => {
        if (newValue) {
          onChange(newValue)
        }
      }}
      error={error}
      disabled={disabled}
    />
  )
}
